import React from 'react';
import ProductPage from '../components/ProductPage';

const HomeEmergency = () => (
  <ProductPage
    eyebrow="Home Emergency Service Plans"
    title={<>Help when a <span className="text-[#FF5C39]">home emergency</span> strikes</>}
    tagline="Support for boiler breakdowns, burst pipes, blocked drains and electrical failures — arranged through our UK network of qualified engineers. Availability confirmed at the time of booking. This is a maintenance service agreement — not an insurance product."
    heroImage="https://images.unsplash.com/photo-1542013936693-884638332954?w=1400&q=80"
    monthlyPrice="Call for a quote"
    annualPrice="From £190.00"
    badge={{ top: 'Speak to our team', value: '0113 548 7557' }}
    includes={[
      'Boiler breakdown & central heating support',
      'Plumbing & drainage emergencies',
      'Electrical breakdown support',
      'Loss of external keys support',
      'Pest infestation support (rats, mice, wasps)',
      'Repair contribution limits per incident',
      'Cancel any time — 14-day cooling off period',
      'Customer service Monday–Friday, 9am–5pm',
    ]}
    notCovered={[
      'Pre-existing issues before your plan started',
      'Appliances outside the property\'s main heating system',
      'Non-emergency cosmetic repairs',
      'Damage caused by wilful neglect',
    ]}
  />
);

export default HomeEmergency;
